import { useApi } from '@/common/ApiHelper';
import { useLoginStore } from '@/login/stores/useLoginStore';
import { ConditionOperator, LogicalOperator } from '@sysarb/sysarb-api/models/common/selection/Selection';
import type Employment from '@sysarb/sysarb-api/models/entities/Employment';
import { Statuses } from '@sysarb/sysarb-api/models/entities/Employment';
import type { QueryOptions } from '@tanstack/vue-query';
import { queryOptions } from '@tanstack/vue-query';

type LegacyEmploymentsOptions = {
    queries: {
        /** Active employments for the current manager's organisation node (legacy Employment entity). */
        getLegacyEmployments: () => QueryOptions<Employment[], Error>;
    };
};

export const legacyEmployments: LegacyEmploymentsOptions = {
    queries: {
        getLegacyEmployments: (): QueryOptions<Employment[], Error> => {
            const { selectedInstance, currentOrganisationNodeId } = useLoginStore();
            const managerIdValue = selectedInstance?.user?.Manager_ID ?? null;
            const nodeId = currentOrganisationNodeId;

            return queryOptions<Employment[], Error>({
                queryKey: ['manager', 'legacy-employments', nodeId, managerIdValue],
                queryFn: async (): Promise<Employment[]> => useApi().employment.getBySelection({
                    Condition: {
                        LogicalOperator: LogicalOperator.And,
                        Conditions: [
                            {
                                LogicalOperator: LogicalOperator.Or,
                                Conditions: [
                                    {
                                        PropertyName: 'Manager_ID',
                                        ConditionOperator: ConditionOperator.EqualTo,
                                        Value: managerIdValue,
                                    },
                                    {
                                        PropertyName: 'ManagerDeputy',
                                        ConditionOperator: ConditionOperator.Contains,
                                        Value: managerIdValue,
                                    },
                                ],
                            },
                            {
                                PropertyName: 'OrganisationNode_ID',
                                ConditionOperator: ConditionOperator.EqualTo,
                                Value: nodeId,
                            },
                            {
                                PropertyName: 'Status_Value',
                                ConditionOperator: ConditionOperator.EqualTo,
                                Value: Statuses.active,
                            },
                        ],
                    },
                }),
                enabled: () => nodeId != null && managerIdValue != null,
            });
        },
    },
};
